import React from 'react';
import Modal from './modal';
import I18n from 'i18n-js';
import { RCButton, RCIcon } from '@reverbdotcom/cadence/components';
import { TrashOIcon } from '@reverbdotcom/cadence/icons/react';

interface ModalConfirmationProps {
  title: string;
  content: React.ReactNode;
  confirmButtonText?: string;
  isOpen: boolean;
  onConfirm: ()=> void;
  onRequestClose: ()=> void;
}
export function ModalConfirmation({
  title,
  content,
  confirmButtonText = I18n.t('commons.modalConfirmation.confirm'),
  isOpen,
  onConfirm,
  onRequestClose,
}: ModalConfirmationProps ) {
  return (
    <Modal
      isOpen={isOpen}
      shouldCloseOnOverlayClick
      onRequestClose={onRequestClose} // necessary for shouldCloseOnOverlayClick
      size="narrow"
      subClass="confirmation"
    >
      <div className="modal-confirmation">
        <div className="modal-confirmation__porthole">
          <RCIcon
            svgComponent={TrashOIcon}
          />
        </div>
        <div className="modal-confirmation__header">
          {title}
        </div>
        <div className="modal-confirmation__content">
          {content}
        </div>
        <div className="modal-confirmation__actions">
          <RCButton
            variant="primary"
            theme="danger"
            onClick={onConfirm}
          >
            {confirmButtonText}
          </RCButton>
          <RCButton
            variant="secondary"
            onClick={onRequestClose}
          >
            {I18n.t('commons.modalConfirmation.cancel')}
          </RCButton>
        </div>
      </div>
    </Modal>
  );
}
